export abstract class MarkdownBlock {
  /**
   * Each markdown block must export a valid markdown string
   */
  abstract toString(): string;
}
